module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/integrations/connect-galleries/modals/delete-gallery-modal/delete-gallery.modal.scss
// module id = ./web/modern/components/integrations/connect-galleries/modals/delete-gallery-modal/delete-gallery.modal.scss
// module chunks = 0